import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form'
import { postNewForm } from '../../../../service';

import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box } from '@chakra-ui/react';
import AdminLayout from '../../Layout';
import FieldGroups from './FieldGroups';

type Props = {
};

function FormBuilderNew({  }: Props) {
  const [fieldGroups, setFieldGroups] = useState([] as any);

  const mutation = useMutation(data => {
    return postNewForm(data);
  }, {
    onSuccess: () => {
      alert('양식을 저장했습니다.');
    }
  });

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();

  function onSubmit(values:any) {
    const newForm = {
      ...values,
      post_type: 'form',
      post_content: JSON.stringify(fieldGroups),
      post_status: 'private'
    }
    
    mutation.mutate(newForm);
  }

  const onUpdateFieldGroups = (list:any[]) => {		
    setFieldGroups(list);
  }

  return (
    <AdminLayout>
      <Flex justify="space-between">
        <Box w="30%">
          <Heading size="xl" pb="5">새로운 양식 추가</Heading>
          <form name="newForm" onSubmit={handleSubmit(onSubmit)}>
            <FormControl isInvalid={!!errors.post_title}>
              <FormLabel htmlFor='post_title'>양식 제목</FormLabel>
              <Input
                id='post_title'
                placeholder='양식 제목'
                {...register('post_title', { required: true })}
              />
              <FormErrorMessage>
                양식 제목은 필수 항목입니다.
              </FormErrorMessage>
            </FormControl>
            <Button mt={4} colorScheme='dgr' isLoading={isSubmitting} type='submit'>
              저장하기
            </Button>
          </form>
        </Box>
        <Box w="65%"> 
          <FieldGroups fieldGroups={fieldGroups} onUpdateFieldGroups={onUpdateFieldGroups} />
        </Box>
      </Flex>
    </AdminLayout>
  );
}

FormBuilderNew.defaultProps = {
};

export default FormBuilderNew;